import Search from "../searchAndSelect/Search";
import useAuth from "@/hooks/useAuth";

interface DesktopTopBarProps {
    className?: string;
    storageId?: string;
    categoryId?: string;
    locationId?: string;
    customerId?: string;
    supplierId?: string;
    productId?: string;
    transactionId?: string;
}

const DesktopTopBar: React.FC<DesktopTopBarProps> = ({ 
    className, 
    storageId, 
    categoryId, 
    locationId,
    customerId, 
    supplierId,
    productId,
    transactionId
}) => {
    const { tokenIsValid } = useAuth();
    const showSearch = tokenIsValid === true && Boolean(storageId);

    return (
        <div
            id={`desktop-top-bar`}
            className={`
			h-16
			flex
			flex-row
			justify-between
			fixed
            top-0
            items-center
            ${className ? className : ''}
        `}>
            <div className={`
                m-auto
                w-[1024px]
                flex
                items-center
            `}>
                {showSearch && storageId ? (
                    <Search
                        storageId={storageId} 
                        categoryId={categoryId}
                        locationId={locationId}
                        customerId={customerId}
                        supplierId={supplierId}
                        productId={productId}
                        transactionId={transactionId}
                        className={`w-full lg:max-w-[800px]`}
                    />
                ) : null}
            </div>
        </div>
    )
}

export default DesktopTopBar
